import React from "react";

import { OptionProvider } from "../OptionProvider";
import { ComboBoxOption } from "./types";

/**
 * Sestaví pole komponent `<OptionProvider> na základě vstupního parametru `options`.
 * @param options data, na základě kterých se vytvoří pole optionů
 */
export const getOptionProviders = (options: ReadonlyArray<ComboBoxOption>) => {
    return options.map(option => {
        const key = option.value + "";
        return (
            <OptionProvider key={key} hide={ option.hide } {...{ option }} />
        );
    });
};
